import React, { useEffect } from 'react';
import LandingNavbar from '../components/Landing/LandingNavbar';
import LandingFooter from '../components/Landing/LandingFooter';
import './landing.css';
import aiServices from '../assets/ai_services.png';

const ServicesPage: React.FC = () => {
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.service-card, .process-step').forEach(el => {
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div className="main-landing-admin">
            <LandingNavbar />

            <section className="hero-sub">
                <div className="container hero-sub-container">
                    <div className="hero-sub-content">
                        <h1 className="section-title gradient-text" style={{ textAlign: 'left', marginBottom: '1.5rem' }}>Our <span>AI Services</span></h1>
                        <p className="hero-description" style={{ color: 'rgba(255,255,255,0.85)', fontSize: '1.25rem', lineHeight: '1.6' }}>
                            Elevate your business with our comprehensive suite of artificial intelligence services tailored to your specific needs.
                        </p>
                        <div style={{ marginTop: '2rem' }}>
                            <div className="tech-badge" style={{ display: 'inline-block', marginRight: '1rem', marginBottom: '1rem' }}>Bespoke Solutions</div>
                            <div className="tech-badge" style={{ display: 'inline-block', marginRight: '1rem', marginBottom: '1rem' }}>Expert Consulting</div>
                        </div>
                    </div>

                    <div className="featured-image-container">
                        <img src={aiServices} alt="AI Services" className="featured-image" />
                    </div>
                </div>
            </section>

            <section style={{ padding: '6rem 0' }}>
                <div className="container">
                    <h2 className="section-title">Specialized <span>Solutions</span></h2>
                    <div className="services-grid">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-magic"></i>
                            </div>
                            <h3>AI Strategy Consulting</h3>
                            <p>We help you identify high-impact AI opportunities and develop a roadmap for successful implementation and scaling.</p>
                            <ul className="service-features">
                                <li>Innovation Workshops</li>
                                <li>ROI Analysis</li>
                                <li>Maturity Assessment</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">
                                <div className="icon-inner"><i className="fas fa-code"></i></div>
                            </div>
                            <h3>Custom AI Development</h3>
                            <p>From custom LLMs to computer vision systems, we build bespoke AI solutions that address your unique challenges.</p>
                            <ul className="service-features">
                                <li>Bespoke Model Training</li>
                                <li>API Development</li>
                                <li>Legacy Integration</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-database"></i>
                            </div>
                            <h3>Big Data Analytics</h3>
                            <p>Transform your raw data into actionable intelligence with our high-performance data processing pipelines.</p>
                            <ul className="service-features">
                                <li>Data Governance</li>
                                <li>Predictive Modeling</li>
                                <li>Interactive Visualization</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-comments"></i>
                            </div>
                            <h3>Conversational AI</h3>
                            <p>Deploy intelligent chatbots and voice assistants that provide 24/7 support and enhance user engagement.</p>
                            <ul className="service-features">
                                <li>Multi-language Support</li>
                                <li>Integrations</li>
                                <li>Sentiment Analysis</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-server"></i>
                            </div>
                            <h3>MLOps & Infrastructure</h3>
                            <p>We ensure your AI models are scalable, reliable, and easily maintainable with modern MLOps practices.</p>
                            <ul className="service-features">
                                <li>Cloud Deployment</li>
                                <li>Performance Monitoring</li>
                                <li>Model Retraining</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-user-shield"></i>
                            </div>
                            <h3>AI Maintenance</h3>
                            <p>Continuous monitoring and optimization of your AI systems to ensure they remain accurate and effective over time.</p>
                            <ul className="service-features">
                                <li>Ongoing Support</li>
                                <li>Security Audits</li>
                                <li>Model Updates</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <LandingFooter />
        </div>
    );
};

export default ServicesPage;
